let ENGLISH = "en"
let JAPANESE = "jp"
let TRADITIONAL_CHINESE = "tc"
let SIMPLIFIED_CHINESE = "sc"

export const WazarenTagsMapping = {
    
    // Category: Action
    1: {
        [ENGLISH]: "Basic",
        [JAPANESE]: "ベーシック",
        [TRADITIONAL_CHINESE]: "基礎",
        [SIMPLIFIED_CHINESE]: "基础",
    },
    2: {
        [ENGLISH]: "Snake",
        [JAPANESE]: "スネーク",
        [TRADITIONAL_CHINESE]: "蛇",
        [SIMPLIFIED_CHINESE]: "蛇",
    },
    3: {
        [ENGLISH]: "16",
        [JAPANESE]: "16",
        [TRADITIONAL_CHINESE]: "16",
        [SIMPLIFIED_CHINESE]: "16",
    },
    4: {
        [ENGLISH]: "8",
        [JAPANESE]: "8",
        [TRADITIONAL_CHINESE]: "8",
        [SIMPLIFIED_CHINESE]: "8",
    },
    5: {
        [ENGLISH]: "7",
        [JAPANESE]: "7",
        [TRADITIONAL_CHINESE]: "彌七",
        [SIMPLIFIED_CHINESE]: "彌七",
    },
    6: {
        [ENGLISH]: "Windmill",
        [JAPANESE]: "大圈",
        [TRADITIONAL_CHINESE]: "大圈",
        [SIMPLIFIED_CHINESE]: "大圈",
    },
    7: {
        [ENGLISH]: "32",
        [JAPANESE]: "32",
        [TRADITIONAL_CHINESE]: "32",
        [SIMPLIFIED_CHINESE]: "32",
    },
    8: {
        [ENGLISH]: "24",
        [JAPANESE]: "24",
        [TRADITIONAL_CHINESE]: "24",
        [SIMPLIFIED_CHINESE]: "24",
    },
    9: {
        [ENGLISH]: "9",
        [JAPANESE]: "9",
        [TRADITIONAL_CHINESE]: "9",
        [SIMPLIFIED_CHINESE]: "9",
    },
    10: {
        [ENGLISH]: "凸16",
        [JAPANESE]: "凸16",
        [TRADITIONAL_CHINESE]: "凸16",
        [SIMPLIFIED_CHINESE]: "凸16",
    },
    11: {
        [ENGLISH]: "凸32",
        [JAPANESE]: "凸32",
        [TRADITIONAL_CHINESE]: "凸32",
        [SIMPLIFIED_CHINESE]: "凸32",
    },
    12: {
        [ENGLISH]: "凸24",
        [JAPANESE]: "凸24",
        [TRADITIONAL_CHINESE]: "凸24",
        [SIMPLIFIED_CHINESE]: "凸24",
    },
    13: {
        [ENGLISH]: "Fire Type",
        [JAPANESE]: "烈系",
        [TRADITIONAL_CHINESE]: "烈系",
        [SIMPLIFIED_CHINESE]: "烈系",
    },
    14: {
        [ENGLISH]: "Heraldry",
        [JAPANESE]: "",
        [TRADITIONAL_CHINESE]: "紋章",
        [SIMPLIFIED_CHINESE]: "纹章",
    },
    15: {
        [ENGLISH]: "Holy Beasts Type",
        [JAPANESE]: "聖獣系",
        [TRADITIONAL_CHINESE]: "聖獸系",
        [SIMPLIFIED_CHINESE]: "圣兽系",
    },
    16: {
        [ENGLISH]: "Miyuki Type",
        [JAPANESE]: "深雪系",
        [TRADITIONAL_CHINESE]: "深雪系",
        [SIMPLIFIED_CHINESE]: "深雪系",
    },
    17: {
        [ENGLISH]: "摩耶系",
        [JAPANESE]: "摩耶系",
        [TRADITIONAL_CHINESE]: "摩耶系",
        [SIMPLIFIED_CHINESE]: "摩耶系",
    },
    18: {
        [ENGLISH]: "金剛系",
        [JAPANESE]: "金剛系",
        [TRADITIONAL_CHINESE]: "金剛系",
        [SIMPLIFIED_CHINESE]: "金剛系",
    },
    19: {
        [ENGLISH]: "Chinese Wazarens",
        [JAPANESE]: "中国技",
        [TRADITIONAL_CHINESE]: "中國技",
        [SIMPLIFIED_CHINESE]: "中国技",
    },
    20: {
        [ENGLISH]: "夜技",
        [JAPANESE]: "夜技",
        [TRADITIONAL_CHINESE]: "夜技",
        [SIMPLIFIED_CHINESE]: "夜技",
    },
    21: {
        [ENGLISH]: "Torch",
        [JAPANESE]: "火把",
        [TRADITIONAL_CHINESE]: "火把",
        [SIMPLIFIED_CHINESE]: "火把",
    },
    22: {
        [ENGLISH]: "Head flower",
        [JAPANESE]: "頭の花",
        [TRADITIONAL_CHINESE]: "頭花",
        [SIMPLIFIED_CHINESE]: "头花",
    },
    23: {
        [ENGLISH]: "Samsara",
        [JAPANESE]: "輪廻",
        [TRADITIONAL_CHINESE]: "輪廻",
        [SIMPLIFIED_CHINESE]: "轮迴",
    },
    24: {
        [ENGLISH]: "Spinosaurus",
        [JAPANESE]: "旋龙",
        [TRADITIONAL_CHINESE]: "旋龍",
        [SIMPLIFIED_CHINESE]: "旋龙",
    },
}
